var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.045 1.425H6.955a6.037 6.037 0 0 0-6.03 6.03v10.09a6.037 6.037 0 0 0 6.03 6.03h10.09a6.037 6.037 0 0 0 6.03-6.03V7.455a6.037 6.037 0 0 0-6.03-6.03m4.59 16.12c0 2.531-2.06 4.59-4.59 4.59H6.955a4.596 4.596 0 0 1-4.59-4.59V7.455c0-2.53 2.059-4.59 4.59-4.59h10.09c2.53 0 4.59 2.06 4.59 4.59z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.05,
  d: "M12.5 7.475A5.53 5.53 0 0 0 6.975 13a5.53 5.53 0 0 0 5.525 5.525A5.53 5.53 0 0 0 18.025 13 5.53 5.53 0 0 0 12.5 7.475Zm0 9.82A4.3 4.3 0 0 1 8.204 13 4.3 4.3 0 0 1 12.5 8.704 4.3 4.3 0 0 1 16.796 13a4.3 4.3 0 0 1-4.296 4.296Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 0.6,
  d: "M19.3 6.5a1.3 1.3 0 1 0-2.6 0 1.3 1.3 0 0 0 2.6 0Z"
})));
export default SvgInstagram;